import { BodySmallRegular, LabelRegular, YStack } from 'smoothie';

export interface QATestDetailField {
    label: string;
    value: string;
}

export const QATestDetails = ({ fields }: { fields: QATestDetailField[] }) => (
    <YStack gap={8} padding={12} backgroundColor="$gray100">
        {fields.map((field) => (
            <YStack key={field.label} gap={2}>
                <LabelRegular color="$gray1200">{field.label}</LabelRegular>
                <BodySmallRegular color="$gray900">
                    {field.value}
                </BodySmallRegular>
            </YStack>
        ))}
    </YStack>
);
